<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'personal-myLoanRequest',
  components: {
    PageTable,
  },
}
</script>
